
import styles from './VideoTeamInfo.module.css';
import { useQuery } from '@tanstack/react-query';
import { getUrl } from '../../App';


const fetch_teams = async (id) => {
    const response = await fetch(`${getUrl()}/api/teams/${id}`, { credentials: 'include', });
    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }
    return await response.json();
}

const fetch_logs = async (game_id) => {
    const response = await fetch(`${getUrl()}/api/logs/?game=${game_id}`, { credentials: 'include', });

    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }
    return await response.json();
}

function VideoTeamInfo({ id, BallTime, BallDistance, WalkedDistance, onSelectLog }) {

    const team = useQuery({
        queryKey: ['team', id],
        queryFn: () => fetch_teams(id),
        staleTime: 5 * 60 * 1000, // Cache data for 5 minutes
        cacheTime: 5 * 60 * 1000,
    });

    const isBerlinUnited = team.data?.name === 'Berlin United';

    const logs = useQuery({
        queryKey: ['logs', id],
        queryFn: () => fetch_logs(id),
        enabled: isBerlinUnited && !!team.data,
        staleTime: 5 * 60 * 1000,
        cacheTime: 5 * 60 * 1000,
    });

    if (team.isLoading) {
        return <div></div>;
    }

    return (
        <div>
            <h1 className={`${styles.title}`}>{team.data.name}</h1>
            <div className={`${styles.team}`}>
                <div>Ball Possession:</div><div>{`${BallTime} s`}</div>
                <div>Ball Moved:</div><div>{`${BallDistance} m`}</div>
                <div>Distance Walked:</div><div>{`${WalkedDistance} m`}</div>
            </div>

            {isBerlinUnited && (
                <div className={`${styles.log_card}`}>
                    <h2>Logs</h2>
                    {logs.isLoading && <div>Loading logs...</div>}
                    {logs.isError && <div>Error loading logs</div>}
                    {logs.data && logs.data.length > 0 ? (
                        <ul>
                            {logs.data.map((log) => (
                                <li key={log.id}>
                                    {/* TODO: pass video here */}
                                    <button type="button" onClick={() => onSelectLog?.()}>
                                        {`ID: ${log.id} Player: ${log.player_number}`}
                                    </button>
                                </li>

                            ))}
                        </ul>
                    ) : (
                        !logs.isLoading && <div>No logs found.</div>
                    )}
                </div>
            )}
        </div>
    );

}

export default VideoTeamInfo